<template>
  <div class="set_main">
    <div class="account-tit">
      <h1 class="title">
        {{ $t('message["1015"]') }}
      </h1>
    </div>
    <div class="set-account-tip-t">
      <a-alert
        :message="setTips"
        type="warning"
        show-icon
      />
    </div>
    <a-form
      :form="form"
      :hide-required-mark="true"
      class="inquiry-detail"
      @submit.prevent="handleSubmit"
    >
      <a-form-item
        :label="loginTitTxt"
      >
        <!-- <a-input
          v-decorator="decorators.username"
          placeholder="请输入登录帐号"
        /> -->
        <a-popover
          title=""
          trigger="focus"
          overlay-class-name="input-tip-tip-box"
          :arrow-point-at-center="true"
          :destroy-tooltip-on-hide="true"
        >
          <template slot="content">
            <p>3-15{{ $t('message["369"]') }}</p>
          </template>
          <a-input
            v-decorator="decorators.username"
            :placeholder="setAccountPlace"
          />
        </a-popover>
      </a-form-item>
      <a-form-item
        :label="pwdTitTxt"
        class="password-item"
      >
        <a-input
          v-decorator="decorators.password"
          :placeholder="pwdPlaceholder"
          type="password"
        />
      </a-form-item>
      <a-form-item>
        <div class="form_btn">
          <a-button
            type="primary"
            html-type="submit"
          >
            {{ $t('message["1161"]') }}
          </a-button>
          <a-button
            type="default"
            @click="resetForm"
          >
            {{ $t('message["896"]') }}
          </a-button>
        </div>
      </a-form-item>
    </a-form>
    <bind-dialog
      ref="bindDialog"
      bind-type="user"
      :value="form.getFieldValue('username')"
    />
  </div>
</template>

<script>
import BindDialog from '@/components/pc/account/BindDialog'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  components: {
    BindDialog
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('account/modify', ['decorators']),
    loginTitTxt () {
      return this.$t('message["200"]')
    },
    pwdTitTxt () {
      return this.$t('message["632"]')
    },
    pwdPlaceholder () {
      return this.$t('message["784"]')
    },
    setTips () {
      return this.$t('message["953"]')
    },
    setAccountPlace () {
      return this.$t('message["1015"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('account/modify', ['setUser']),
    ...mapMutations('account/modify', ['setUserid']),
    handleSubmit (e) {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const chain = await this.setUser()
          chain.params(values)
            .onSuccess(res => {
              this.$router.push({ name: 'AccountInfo' })
            })
            .onNetSuccess(raw => {
              let res = raw.data
              if (res.error === 104) {
                this.$refs.bindDialog.changeLimitDialog(true)
                this.setUserid(res.payload.binduserid)
                // this.binduserid = res.payload.binduserid
              } else {
                if (res.error && res.error !== 102) {
                  this.$message.warn(res.message || res.payload[0].message)
                }
              }
            })
            .setForm(this.form)
            .config({ warn: false })
            .fetch()
        }
      })
    },
    // 跳转到个人信息
    resetForm () {
      this.$router.push({ name: 'AccountInfo' })
    }
  }
}
</script>

<style scoped lang="scss">
.set_main {
 padding: 24px 40px;
 .account-tit {
   margin-bottom: 24px;
 }
  .form_btn {
  button {
    margin-right: 16px
  }
}
}
.password-item {
  margin-bottom: 24px !important;
}
// .set-account-user-tip {
//   color: #b3b3b3;
//   margin-left: 12px;
// }
.set-account-tip-t::v-deep {
  margin-bottom: 24px;
  .ant-alert-warning{
      background: #FFF4E7;
      border: 1px solid #F6A953;
      border-radius: 4px;
    }
}
</style>
